module.exports = __webpack_public_path__ + "img/54.31f63621.jpg";